import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";

function CheckNumber({ name, onChange, defaultValue = -1 }) {
  const [value, setValue] = useState(defaultValue);
  const handleValueChanged = useCallback(
    (event) => {
      setValue(event.target.value);
      if (onChange instanceof Function) onChange(event.target.value);
    },
    [onChange]
  );

  const [enabled, setEnabled] = useState(false);
  const handleEnabledChanged = useCallback(
    (event) => {
      setEnabled(event.target.checked);
      if (!event.target.checked)
        handleValueChanged({ target: { value: defaultValue } });
      else handleValueChanged({ target: { value: 0 } });
    },
    [handleValueChanged, defaultValue]
  );

  return (
    <div className="flex gap-1">
      <FormControlLabel
        className="w-20"
        control={
          <Checkbox
            checked={enabled}
            onChange={handleEnabledChanged}
            color="primary"
          />
        }
        label={name}
      />

      <TextField
        required
        type="number"
        size="small"
        variant="outlined"
        className="flex-1"
        label={name}
        value={enabled ? value : 0}
        disabled={!enabled}
        onChange={handleValueChanged}
        InputLabelProps={{ shrink: true }}
      />
    </div>
  );
}

export default CheckNumber;
